<h3 class="modal__title">{{ data.heading | transloco }}</h3>
<mat-dialog-content>
  <p class="text--accent text--center">
    {{ (data.textHighlightTop | transloco) ?? "" }}
  </p>

  <ng-container *ngIf="!data.lomyLogo">
    <p class="text--center" *ngFor="let item of data.text">
      {{ item | transloco }}
    </p>
  </ng-container>

  <ng-container *ngIf="data.rules">
    <div [innerHTML]="data?.rules"></div>
  </ng-container>
  <ng-container *ngIf="data.lomyLogo">
    <div class="text--center">
      <ng-container *ngFor="let item of data.text; index as i">
        <span>{{ item !== "lomy-logo" ? (item | transloco) : "" }}</span>

        <p *ngIf="data.text[i - 1] == 'lomy-logo'"></p>
        <span
          ><app-lomy-logo *ngIf="item === 'lomy-logo'" size="p"></app-lomy-logo
        ></span>
      </ng-container>
    </div>
  </ng-container>

  <p class="text--accent text--center">
    {{ (data.textHighlightBottom | transloco) ?? "" }}
  </p>
</mat-dialog-content>

<mat-dialog-actions
  [ngClass]="{ 'mat-dialog__actions': data.showCancelBtn }"
  [align]="'center'"
>
  <app-button
    *ngIf="data.showCancelBtn"
    buttonType="secondary"
    [text]="data.cancelButtonText || 'global.cancel' | transloco"
    [fullWidth]="data.showCancelBtn"
    [isBtnSmall]="true"
    mat-dialog-close
    (click)="onCancel.emit(data.id)"
  ></app-button>

  <app-button
    [text]="data.okButtonText | transloco"
    [fullWidth]="data.showCancelBtn"
    [isBtnSmall]="true"
    (click)="onSave.emit(data.id)"
    mat-dialog-close
  ></app-button>
</mat-dialog-actions>
